export default {
  state: {
    token: undefined,
    loginUser: undefined,
    HUBSettings: {},
  },
  getters: {
    token(state) {
      return state.token;
    },
    loginUser(state) {
      return state.loginUser;
    },
    HUBSettings(state) {
      return state.HUBSettings;
    },
    currentFunction(state) {
      return state.HUBSettings.currentFunction;
    },
    currentLearningType(state) {
      return state.HUBSettings.currentLearningType;
    },
    currentTheme(state) {
      return state.HUBSettings.currentTheme;
    },
    currentModule(state) {
      return state.HUBSettings.currentModule;
    },
    currentClient(state) {
      return state.HUBSettings.currentClient;
    },
    levelUp(state) {
      return state.HUBSettings.levelUp;
    },
    runningModule(state) {
      return state.HUBSettings.runningModule;
    },
  },
  mutations: {
    setToken(state, token) {
      state.token = token;

      if (token) {
        localStorage.setItem('hub-facilitator-portal-token', token);
      } else {
        localStorage.removeItem('hub-facilitator-portal-token');
      }
    },

    setLoginUser(state, loginUser) {
      state.loginUser = loginUser;
    },

    /**
     * Set an object as new HUBSettings
     */
    setHUBSettings(state, HUBSettings) {
      state.HUBSettings = HUBSettings || {};

      if (HUBSettings) {
        localStorage.setItem('hub-facilitator-portal-settings', JSON.stringify(HUBSettings));
      } else {
        localStorage.removeItem('hub-facilitator-portal-settings');
      }
    },

    /**
     * Add a key/value object to user settings object
     */
    setHUBSettingItems(state, items) {
      state.HUBSettings = { ...state.HUBSettings, ...items };
      localStorage.setItem('hub-facilitator-portal-settings', JSON.stringify(state.HUBSettings));
    },
  },

  actions: {
    async createSession({ commit }, { token, loginUser, settings }) {
      commit('setToken', token);
      commit('setLoginUser', loginUser);
      commit('setHUBSettings', settings);
    },

    async updateAuthToken({ commit }, { newToken }) {
      commit('setToken', newToken);
    },

    async clearSession({ commit }) {
      commit('setToken');
      commit('setLoginUser');
    },
  },
};
